__turbopack_context__.v({
  "HeroWithMedia": "Upk4Ka_HeroWithMedia",
  "HeroWithMedia__Header": "Upk4Ka_HeroWithMedia__Header",
  "HeroWithMedia__ImageContainer": "Upk4Ka_HeroWithMedia__ImageContainer",
  "HeroWithMedia__Media": "Upk4Ka_HeroWithMedia__Media",
  "HeroWithMedia__Text": "Upk4Ka_HeroWithMedia__Text",
  "HeroWithMedia__TextWrapper": "Upk4Ka_HeroWithMedia__TextWrapper",
});
